<template>
    <div class="az-form-content" style="padding-bottom: 0 !important;">
        <v-container fluid grid-list-xl>
            <v-layout wrap align-top style="min-height: 300px">
                <v-flex xs12 sm8 d-flex>
                    <az-text-view label="Descrição"
                                        :text="value.descricao"
                                        v-if="visualizando"/>
                    <v-textarea
                            v-else
                            rows="8"
                            v-model="value.descricao"
                            label="Descrição"
                            name="Descrição"
                            placeholder="Ex. Declaro que possuo CNPJ ativo..."
                            v-validate="'required'"
                            class="descricao-termo required-field"
                            :error-messages="errors.collect('Descrição')"/>
                </v-flex>
                <v-flex xs12 sm2 d-flex>
                    <az-text-view label="Tipo"
                                        :text="value.tipo | azEnum(tiposTermoAceite)"
                                        v-if="visualizando"/>

                  <v-select v-else label="Tipo" name="Tipo" placeholder="Selecione" style="margin-top: 18px !important;"
                            v-model="value.tipo" item-text="texto" item-value="valor"
                            :menu-props="{ top: false, offsetY: true }"
                            class="required-field" v-validate="'required'"
                            :error-messages="errors.collect('Tipo')"
                            :items="converterEnumParaSelect(tiposTermoAceite)"/>
                </v-flex>
                <v-flex xs12 sm2 d-flex>
                    <az-text-view label="Impeditivo"
                                        :text="value.impeditivo ? 'Sim' : 'Não'"
                                        v-if="visualizando"/>
                    <v-select v-else label="Impeditivo" name="Impeditivo" placeholder="Selecione" style="margin-top: 18px !important;"
                              v-model="value.impeditivo" item-text="texto" item-value="valor"
                              :menu-props="{ top: false, offsetY: true }"
                              class="required-field" v-validate="'required'"
                              :error-messages="errors.collect('Impeditivo')"
                              :items="opcoesImpeditivo"/>
                </v-flex>
                <v-flex xs12 sm2 d-flex>
                    <az-text-view label="Situação"
                                        :text="value.situacao | azEnum(situacoesAtivoInativo)"
                                        v-if="visualizando"/>
                    <v-select v-else label="Situação" name="Situação" placeholder="Selecione" style="margin-top: 18px !important;"
                              v-model="value.situacao" item-text="texto" item-value="valor"
                              :menu-props="{ top: false, offsetY: true }"
                              class="required-field" v-validate="'required'"
                              :error-messages="errors.collect('Situação')"
                              :items="converterEnumParaSelect(situacoesAtivoInativo)"/>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import {situacoesAtivoInativo, tiposTermoAceite} from '@/commons/constants'

    export default {
        name: 'TermoDados',
        inject: ['$validator'],
        props: {
            value: {
                required: true
            },
            editando: {
                type: Boolean,
                default: false
            }
        },
        data(){
          return{
            situacoesAtivoInativo,
            tiposTermoAceite,
            opcoesImpeditivo: [
              {valor: true, texto: 'Sim'},
              {valor: false, texto: 'Não'}
            ]
          }
        },
        computed: {
            visualizando() {
                return !this.editando
            }
        },
        methods:{
          converterEnumParaSelect(opcoes){
            return Object.entries(opcoes).map((e) => (
                {valor: e[0], texto: e[1]}
            ))
          }
        }
    }
</script>
<style lang="stylus">
.descricao-termo
  textarea
    margin-top 5px
</style>
